<template>
  <!-- api-key="AIzaSyA9iMpjstgjVffJc2sEPealV1IC4f4nCEQ" -->
  <GoogleMap api-key="AIzaSyAboxdDSraLV0k-tlVX0dSYIM3Fpp23EV0" style="height: 700px;" :center="mapCenter" :zoom="7">
    <template v-for="station in stations" :key="station.nid">
      <Marker
        :options="{
          position: {
            lat: station.lat,
            lng: station.lng
          }
        }"
      />
    </template>
  </GoogleMap>

</template>

<script>
import { defineComponent, ref } from 'vue';
import { GoogleMap, Marker } from 'vue3-google-map';

export default defineComponent({
  props: {
    serviceID: String,
    gasStations: Array
  },

  components: { GoogleMap, Marker },

  setup(props) {
    const stations = ref(props.gasStations);

    stations.value.map((station) => {
      station.lat = parseFloat(station.lat);
      station.lng = parseFloat(station.lng);

      return station;
    })

    // Return all the stations if there is not service ID sent in the URL
    if (!props.serviceID)
        return {stations: stations.value, mapCenter: stations.value[0]};

    // Filter stations by the service (service ID from the url)
    stations.value.filter((station, i, stations) => {
      const services = station.services;

      if (!services.includes(parseInt(props.serviceID))) {
        return false;
      }

      return true;
    });

     return {stations: stations.value, mapCenter: stations.value[0]};
  },
})
</script>
